import React from 'react';
import TopBarChinese from "../components/TopBarChinese";
import FooterChinese from "../components/FooterChinese";
import "../App.css";
import ContactFormChinese from '../components/ContactFormChinese';

function ConnectChinese() {
  return (
    <div className="App">
      <TopBarChinese />
      <div className="App-header-services" style={{ padding: '8vw 8px 8px 8px', minHeight: '60vh' }}>
        <div className="connected-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title">保持聯繫</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
            在 CHC，我們致力於用心照護您所摯愛的家人，並為您帶來安心與信賴。我們的專業照護人員及個人支援服務團隊，視其工作為神聖使命，非僅一般職務。我們以同理心為本，視您的摯愛如同自己的家人般悉心照料 ---- 以尊重、耐心與真誠悉心照

料您的親人。

我們理解將摯愛交由他人照護，往往伴隨情感上的波動與壓力。 為此，我們堅持維持公開且透明的溝通機制，並定期提供迅速詳實的照護報告，使您能隨時掌握照護狀況。

選擇 CHC，您可安心放心，確信摯愛親人正接受專業且細膩的照護，讓您無後顧之憂，專注於自身生活與工作，我們則全力提供所需的支持、關懷與照料。
          </p>
          {/* <p style={{ fontSize: '1rem', color: '#555' }}>
            在 Connection Seniorcare，我們致力於促進有意義的關係，並確保與客戶及其家人之間的無縫溝通。
          </p> */}
        </div>
      </div>
      <ContactFormChinese />
      <FooterChinese />
    </div>
  );
}

export default ConnectChinese;